import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import { apiLoginUrl } from "../api/client";
const FROM_KEY = "aisearch_from";
// Same-origin relative-path allowlist — refuses protocol-relative ("//evil"),
// absolute ("https://evil"), and header-injecting values. Mirrors the
// backend's _safe_redirect so a hostile sessionStorage value (set by
// XSS/extension/co-worker prank) can't turn this login click into an
// open-redirect to attacker-controlled HTML.
function safeFrom(v) {
    if (!v || typeof v !== "string" || v.length > 512)
        return "/";
    if (v.includes("\r") || v.includes("\n") || v.includes("\x00"))
        return "/";
    if (!v.startsWith("/"))
        return "/";
    if (v.length >= 2 && (v[1] === "/" || v[1] === "\\"))
        return "/";
    return v;
}
export default function LoginPage() {
    const location = useLocation();
    const onClick = () => {
        // Two sources, in priority order:
        // 1. Router state (set by RequireAuth this session) — fresh deep-link intent
        // 2. Default home
        //
        // We deliberately do NOT fall back to sessionStorage here. The backend
        // /api/auth/callback usually 302s direct to redirect_after, so the SPA
        // AuthCallback page (which clears sessionStorage) never runs. A stale
        // aisearch_from from a prior session would silently re-route a fresh
        // login (post-logout) to someone else's page. Always start fresh from
        // router state OR home.
        const stateFrom = location.state?.from;
        const from = safeFrom(stateFrom);
        sessionStorage.setItem(FROM_KEY, from);
        window.location.href = apiLoginUrl(from);
    };
    return (_jsx("div", { className: "login-shell", children: _jsxs("div", { className: "login-card", children: [_jsx("img", { src: "/dividia-logo.png", alt: "Dividia", className: "login-logo" }), _jsx("h1", { children: "AI Search" }), _jsx("p", { children: "Sign in with your work or school Microsoft account." }), _jsx("button", { className: "primary", onClick: onClick, children: "Sign in with Microsoft" }), _jsx("p", { className: "login-note", children: "Access is by allowlist. If sign-in fails with \"not on the allowlist\", your Dividia contact has not added your email yet." })] }) }));
}
